import { motion } from "framer-motion";

export default function WhyThisMatters() {
  return (
    <section className="relative overflow-hidden" data-testid="why-this-matters">
      {/* Background video (drop /wildfire-bg.mp4 into public to activate) with image poster fallback */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        poster="/wildfire-poster.jpg"
        data-testid="why-bg-video"
      >
        <source src="/wildfire-bg.mp4" type="video/mp4" />
      </video>

      {/* Lighter overlay so the flames stay visible; darker at bottom for text legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/55 to-background/20" />
      <div className="absolute inset-0 bg-background/15" />

      <div className="relative px-6 md:px-12 max-w-5xl mx-auto py-28 sm:py-36">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-ember">Why This Matters</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight max-w-3xl">
            Every year, wildfires turn millions of acres of forest to ash.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed">
            Homes lost. Wildlife displaced. Communities left to rebuild from nothing. The headlines fade,
            but the scars remain for decades — and the forests don't grow back on their own.
          </p>
          <p className="mt-5 text-lg sm:text-xl font-display font-semibold text-foreground max-w-2xl leading-relaxed">
            AfterBurn exists to change that ending. We turn <span className="text-ember">ashes</span> into
            <span className="text-forest-light"> forests</span> — funding real replanting and real recovery,
            transparently, on-chain.
          </p>
          <p className="mt-6 font-mono text-sm text-muted-foreground/80">
            🔥🌱 From the burn, we rebuild — together.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
